/* global dayjs */
import AMCommonGenericCountdown from '@html/_common/generic_countdown';
import AOAvailabilityDatepicker from '@atomic/organisms/tour_b/availability/picker/datepicker';
import {
  isElementOnScreen,
  byWindowAction,
  sendGoogleEvent,
  smoothScroll,
  byUserInteraction,
  sendRequest,
  libInit,
  parameters,
} from '@html/_common/utils';

export default class AvailabilitySection {
  constructor(
    common,
    eventCategory,
    tourId,
    tourName,
    operatorName,
  ) {
    this.common = common ?? {
      byWindowAction,
      sendGoogleEvent,
      byUserInteraction,
      sendRequest,
      parameters,
      func: { isElementOnScreen, smoothScroll },
      lib: { init: libInit },
    };
    this.eventCategory = eventCategory;
    this.tourId = tourId;
    this.tourName = tourName;
    this.operatorName = operatorName;

    this.availabilityEventCategory = 'Availability Section';
    this.tourDetailEventCategory = 'Tour Detail';

    this.$container = $(`.${AvailabilitySection.getAvailabilitySectionClass()}`);

    this.GLOBAL_HIDDEN_CLASS = 'hid';

    this.SIMILAR_SELECTOR = '.js-am-tour-availability__variant-link-button--similar';
    this.MONTHS_BUTTON_SELECTOR = '.js-ao-tour-availability__filters-button';
    this.MONTHS_DROPDOWN_SELECTOR = '.js-ao-tour-availability__select--departure .js-aa-dropdown';
    this.TRANSPORT_DROPDOWN_SELECTOR = '.js-ao-tour-availability__select--transport .js-aa-dropdown';
    this.ALTERNATIVE_DROPDOWN_SELECTOR = '.js-ao-tour-availability__select--alternative .js-aa-dropdown';
    this.VARIANTS_CONTAINER_SELECTOR = '.js-ao-tour-availability__variants-container';
    this.UNAVAILABLE_BLOCK_SELECTOR = '.js-ao-tour-availability__filters-unavailable';
    this.MONTHS_BOTTOM_BUTTON_SELECTOR = '.js-ao-tour-availability__variants-month-buttons';
    this.SHOW_MORE_BUTTON_SELECTOR = '.js-ao-tour-availability__variants-show-more';
    this.SHOW_MORE_OPERATED_IN_BUTTON_SELECTOR = '.js-ao-tour-availability-departure-card__operated-in--show-more';
    this.SHOW_MORE_OPERATED_IN_BUTTON_LINK_SELECTOR = '.js-ao-tour-availability-departure-card__operated-in--show-more-link';
    this.VARIANT_DATES_LANGUAGES_SHOW_MORE = '.js-am-tour-availability__language--show-more';
    this.VARIANT_DATES_OTHER_LANGUAGES = '.js-am-tour-availability__language--other-languages';
    this.SHOWN_VARIANTS_DATA_SELECTOR = '.js-ao-tour-availability__variants-total-showed';
    this.NEXT_MONTH_BUTTON_SELECTOR = '.js-ao-tour-availability__variants-m-button--right';
    this.PREVIOUS_MONTH_BUTTON_SELECTOR = '.js-ao-tour-availability__variants-m-button--left';
    this.VARIANTS_TITLE_SELECTOR = '.js-ao-tour-availability__variants-title';
    this.VARIANT_VERSION_SELECTOR = '.js-am-tour-availability__variant-version';
    this.VARIANT_VERSION_LINK_SELECTOR = '.js-am-tour-availability__variant-version-link';
    this.ROOM_INFO_ICON_SELECTOR = '.js-am-tour-availability__variant-room-icon';
    this.OTHER_DEPARTURE_SELECTOR = '.js-am-tour-availability-other-departures';

    this.VARIANT_SELECTOR = '.js-am-tour-availability__variant';
    this.DEPARTURE_CARD_SELECTOR = '.js-ao-tour-availability-departure-card';

    this.VARIANTS_CONTAINER_LOAD_CLASS = 'ao-tour-availability__variants-container--loading';
    this.EMPTY_VARIANT_CLASS = 'js-am-tour-availability__variant am-tour-availability__variant am-tour-availability__variant--disabled am-tour-availability__variant--empty';
    this.VARIANT_DISABLED_CLASS = 'am-tour-availability__variant--disabled';
    this.MONTHS_BUTTON_ACTIVE_CLASS = 'ao-tour-availability__filters-button--active';
    this.VARIANT_HIDDEN_CLASS = 'am-tour-availability__variant--hidden';

    this.TRAVELLER_SELECT_SLECTOR = '.js-am-tour-availability__traveller-select';

    this.$variantsContainer = this.$container.find(this.VARIANTS_CONTAINER_SELECTOR);

    this.page = 1;
    this.loading = false;
    this.avlEventIsSent = false;
    this.texts = false;
  }

  initiate() {
    this.initUrgency();

    this.initDateTravellerSelector();

    this.initSimilarLinks();

    this.initMonthSelection();

    this.initTransportSelection();

    this.initAlternativeSelection();

    if (this.common.func.isElementOnScreen(this.$variantsContainer)) {
      this.sendAvlVisibilityEvent(true);
    }

    this.common.byWindowAction(['scroll'], () => {
      if (!this.common.func.isElementOnScreen(this.$variantsContainer)) {
        return;
      }

      this.sendAvlVisibilityEvent(true);
    });

    this.sendDeparturesEvent();

    this.sendMonthPreselectEvent();

    this.initLoadMore();

    this.initiateToolTips();

    this.initRoomInformation();

    this.otherDeparture();

    this.initShowMoreLanguages();

    // Experiment number-of-travellers
    this.$container.on('click', '.js-am-tour-availability__variant-cta--required', () => {
      this.common.sendGoogleEvent(
        this.availabilityEventCategory,
        'Tour Detail Card',
        'Card Blur Out - Click',
      );
    });
  }

  initShowMoreLanguages() {
    $(this.VARIANT_DATES_LANGUAGES_SHOW_MORE).on('click', (event) => {
      const $element = $(event.target);
      $element.parent().find(this.VARIANT_DATES_OTHER_LANGUAGES).removeClass('hid');
      $element.addClass('hid');

      this.common.sendGoogleEvent(
        'TDP',
        'More Languages',
        'Departure Cards',
      );
    });

    $(this.SHOW_MORE_OPERATED_IN_BUTTON_LINK_SELECTOR).on('click', (event) => {
      const $element = $(event.target);
      $element.parent().find(this.SHOW_MORE_OPERATED_IN_BUTTON_SELECTOR).toggleClass('hid', false);
      $element.toggleClass('hid', true);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  initUrgency() {
    const countdown = new AMCommonGenericCountdown('.js-ao-tour-urgency');
    countdown.initiate();
  }

  // eslint-disable-next-line class-methods-use-this
  initDateTravellerSelector() {
    const tourLength = $('main').data('tour-length');
    const datepicker = new AOAvailabilityDatepicker(
      this.common,
      this.tourId,
      tourLength,
      this.availabilityEventCategory,
    );
    datepicker.initiate(this.initShowMoreLanguages.bind(this));
  }

  otherDeparture() {
    this.$container.on('click', this.OTHER_DEPARTURE_SELECTOR, (event) => {
      const $clickedElement = $(event.currentTarget);

      let $previousElement = $clickedElement.prev();
      let count = 0;
      while ($previousElement.hasClass(this.VARIANT_HIDDEN_CLASS)) {
        $previousElement.removeClass(this.VARIANT_HIDDEN_CLASS);
        $previousElement = $previousElement.prev();
        count += 1;
      }

      $clickedElement.remove();

      this.common.sendGoogleEvent(
        this.availabilityEventCategory,
        'Click - Other Unavailable Departures',
        count,
      );
    });
  }

  initLoadMore() {
    this.$container.on('click', this.SHOW_MORE_BUTTON_SELECTOR, () => {
      this.page += 1;
      this.load();

      this.common.sendGoogleEvent(
        this.availabilityEventCategory,
        'Month Selection',
        'More variants',
      );
    });

    this.$container.on('click', this.NEXT_MONTH_BUTTON_SELECTOR, () => {
      const nextMonthIndex = this.$container.find(`.${this.MONTHS_BUTTON_ACTIVE_CLASS}`).index() + 1;
      this.$container.find(this.MONTHS_BUTTON_SELECTOR).eq(nextMonthIndex).click();

      this.common.func.smoothScroll({
        to: $(this.VARIANTS_TITLE_SELECTOR),
        duration: 300,
      });

      this.common.sendGoogleEvent(
        this.availabilityEventCategory,
        'Month Selection',
        'Next',
      );
    });

    this.$container.on('click', this.PREVIOUS_MONTH_BUTTON_SELECTOR, () => {
      const previousMonthIndex = this.$container.find(`.${this.MONTHS_BUTTON_ACTIVE_CLASS}`).index() - 1;
      this.$container.find(this.MONTHS_BUTTON_SELECTOR).eq(previousMonthIndex).click();

      this.common.func.smoothScroll({
        to: $(this.VARIANTS_TITLE_SELECTOR),
        duration: 300,
      });

      this.common.sendGoogleEvent(
        this.availabilityEventCategory,
        'Month Selection',
        'Prev',
      );
    });
  }

  initSimilarLinks() {
    this.common.byUserInteraction('availability-similar-tour', () => {
      this.checkSimilar();
    });

    this.$container.on('click', this.SIMILAR_SELECTOR, () => {
      this.common.sendGoogleEvent(
        this.eventCategory,
        'Click',
        'Similar Tour/Departure',
      );
    });
  }

  initTransportSelection() {
    this.$container.on('change', this.TRANSPORT_DROPDOWN_SELECTOR, () => {
      this.load();

      const transportName = $(`${this.TRANSPORT_DROPDOWN_SELECTOR} option:checked`).text();

      this.common.sendGoogleEvent(
        this.availabilityEventCategory,
        'Transport Selection',
        transportName,
      );
    });
  }

  initAlternativeSelection() {
    this.$container.on('change', this.ALTERNATIVE_DROPDOWN_SELECTOR, () => {
      this.page = 1;
      this.load();

      this.$container.find(this.UNAVAILABLE_BLOCK_SELECTOR).hide();

      const tourName = $(`${this.ALTERNATIVE_DROPDOWN_SELECTOR} option:checked`).text();

      this.common.sendGoogleEvent(
        'Availability Section',
        'Alternative Tour Selection',
        tourName,
      );
    });

    this.$container.on('click', this.VARIANT_VERSION_LINK_SELECTOR, () => {
      const currentType = document.querySelector('main').dataset.private === '1' ? 'Private' : 'Group';
      this.sendOpenAlternativeVersionEvent(currentType);
    });
  }

  initMonthSelection() {
    this.$container.find(this.MONTHS_BUTTON_SELECTOR).click((event) => {
      const $clickedElement = $(event.currentTarget);

      if ($clickedElement.hasClass(this.MONTHS_BUTTON_ACTIVE_CLASS)) {
        return;
      }

      this.page = 1;

      const newOption = $clickedElement.data('val');

      this.$container.find(this.MONTHS_BUTTON_SELECTOR).removeClass(this.MONTHS_BUTTON_ACTIVE_CLASS);
      $clickedElement.addClass(this.MONTHS_BUTTON_ACTIVE_CLASS);

      this.$container.find(this.MONTHS_DROPDOWN_SELECTOR).val(newOption);

      this.avlEventIsSent = false;
      this.load();

      this.common.sendGoogleEvent(
        this.availabilityEventCategory,
        'Month Selection',
        newOption,
        {
          ampEventName: 'tdp_departure_month_clicked',
          tdp_departure_month_clicked_selection: newOption,
        },
      );
    });

    this.$container.find(this.MONTHS_DROPDOWN_SELECTOR).on('change', (event) => {
      const $selectInput = $(event.currentTarget);
      const newOption = $selectInput.val();
      const oldOption = this.getActiveDeparture();

      if (newOption === oldOption) {
        return;
      }

      this.page = 1;

      this.$container.find(this.MONTHS_BUTTON_SELECTOR).removeClass(this.MONTHS_BUTTON_ACTIVE_CLASS);
      this.$container.find(`${this.MONTHS_BUTTON_SELECTOR}[data-val="${newOption}"]`).addClass(this.MONTHS_BUTTON_ACTIVE_CLASS);

      this.avlEventIsSent = false;
      this.load();

      this.common.sendGoogleEvent(
        this.availabilityEventCategory,
        'Month Selection',
        newOption,
      );
    });
  }

  getActiveDeparture() {
    const $travellerDateSelect = $(this.TRAVELLER_SELECT_SLECTOR);

    if ($travellerDateSelect.length) {
      return $travellerDateSelect.data('preselected');
    }

    return this.$container.find(`.${this.MONTHS_BUTTON_ACTIVE_CLASS}`).data('val');
  }

  load() {
    if (!this.loading) {
      this.loading = true;

      this.$container.find(this.MONTHS_BOTTOM_BUTTON_SELECTOR).addClass(this.GLOBAL_HIDDEN_CLASS);
      this.$container.find(this.SHOW_MORE_BUTTON_SELECTOR).addClass(this.GLOBAL_HIDDEN_CLASS);
      this.$container.find(this.PREVIOUS_MONTH_BUTTON_SELECTOR).hide();
      this.$container.find(this.NEXT_MONTH_BUTTON_SELECTOR).hide();

      this.$variantsContainer.addClass(this.VARIANTS_CONTAINER_LOAD_CLASS);

      const month = this.getActiveDeparture();
      const transportId = this.$container.find(this.TRANSPORT_DROPDOWN_SELECTOR).length
        ? this.$container.find(this.TRANSPORT_DROPDOWN_SELECTOR).val()
        : 0;

      const b2bPid = $(this.SHOW_MORE_BUTTON_SELECTOR).data('b2bPid');

      const data = {
        action: 'more_variants',
        page: this.page,
        id: this.tourId,
        month,
        haveTransport: this.$container.find(this.TRANSPORT_DROPDOWN_SELECTOR).length,
        transport_id: transportId,
        b2bPid,
      };

      const groupTourId = this.$container.find(this.ALTERNATIVE_DROPDOWN_SELECTOR).val();
      if (groupTourId) {
        data.group_tour_id = groupTourId;
      }

      if (this.page > 1 && this.$container.find(this.SHOWN_VARIANTS_DATA_SELECTOR).length) {
        data.includeAfter = this.$container
          .find(this.SHOWN_VARIANTS_DATA_SELECTOR)
          .reduce((acc, element) => acc + $(element).data('shown'), 0);
      }

      this.common.sendRequest(
        '/api/tour/load',
        data,
        (response) => {
          if (response && response.status === 'OK') {
            this.$variantsContainer.removeClass(this.VARIANTS_CONTAINER_LOAD_CLASS);

            if (this.page === 1) {
              this.$container.find(this.VARIANT_SELECTOR).remove();
              this.$container.find(this.OTHER_DEPARTURE_SELECTOR).remove();
            }

            const variantsTitle = (month && month !== 0)
              ? $(this.VARIANTS_TITLE_SELECTOR).data('selected-text').replace('{{monthName}}', this.$container.find(`.${this.MONTHS_BUTTON_ACTIVE_CLASS}, .js-am-tour-availability__traveller-select`).data('month-name'))
              : this.$container.find(`.${this.MONTHS_BUTTON_ACTIVE_CLASS}`).text();
            $(this.VARIANTS_TITLE_SELECTOR).text(variantsTitle);

            if (response.html) {
              this.$variantsContainer.append(response.html);

              if (month && month !== 0) {
                this.checkNextPreviousButtons();
              } else if (response.less > 0) {
                this.$container.find(this.SHOW_MORE_BUTTON_SELECTOR).removeClass(this.GLOBAL_HIDDEN_CLASS);
              }
            } else {
              const monthName = (month && month !== 0)
                ? this.$container.find(`.${this.MONTHS_BUTTON_ACTIVE_CLASS}`).text()
                : '';
              const transportName = transportId !== 0
                ? this.$container.find(`${this.TRANSPORT_DROPDOWN_SELECTOR} option[value='${transportId}']`).text()
                : '';
              const tourName = groupTourId !== 0
                ? this.$container.find(`${this.ALTERNATIVE_DROPDOWN_SELECTOR} option[value='${groupTourId}']`).text()
                : '';

              this.$variantsContainer
                .append(`<li class="${this.EMPTY_VARIANT_CLASS}">${AvailabilitySection.buildErrorMessage(tourName, transportName, monthName, response.errors)}</li>`);
            }

            this.sendAvlVisibilityEvent();

            this.loading = false;

            this.checkSimilar();

            this.initShowMoreLanguages();
          } else {
            this.loading = false;
          }
        },
      );
    } else {
      const interval = setInterval(() => {
        if (!this.loading) {
          clearInterval(interval);
          this.load();
        }
      }, 10);
    }
  }

  checkNextPreviousButtons() {
    const $departuresFilters = this.$container.find(this.MONTHS_BUTTON_SELECTOR);
    const $activeDeparturesFilters = this.$container.find(`.${this.MONTHS_BUTTON_ACTIVE_CLASS}`);

    if ($activeDeparturesFilters.index() > 1
        && $activeDeparturesFilters.index() + 1 < $departuresFilters.length
    ) {
      this.$container.find(this.MONTHS_BOTTOM_BUTTON_SELECTOR).removeClass(this.GLOBAL_HIDDEN_CLASS);

      const leftText = this.$container.find(this.PREVIOUS_MONTH_BUTTON_SELECTOR).data('text')
        .replace('{{monthName}}', $departuresFilters.eq($activeDeparturesFilters.index() - 1).data('month-name').replace(/\d+/g, '').trim());
      const rightText = this.$container.find(this.NEXT_MONTH_BUTTON_SELECTOR).data('text')
        .replace('{{monthName}}', $departuresFilters.eq($activeDeparturesFilters.index() + 1).data('month-name').replace(/\d+/g, '').trim());

      this.$container.find(this.PREVIOUS_MONTH_BUTTON_SELECTOR).show().text(leftText);
      this.$container.find(this.NEXT_MONTH_BUTTON_SELECTOR).show().text(rightText);
    } else if ($activeDeparturesFilters.index() > 1) {
      this.$container.find(this.MONTHS_BOTTOM_BUTTON_SELECTOR).removeClass(this.GLOBAL_HIDDEN_CLASS);

      const leftText = this.$container.find(this.PREVIOUS_MONTH_BUTTON_SELECTOR).data('text')
        .replace('{{monthName}}', $departuresFilters.eq($activeDeparturesFilters.index() - 1).data('month-name').replace(/\d+/g, '').trim());
      this.$container.find(this.PREVIOUS_MONTH_BUTTON_SELECTOR).show().text(leftText);
    } else if ($activeDeparturesFilters.index() + 1 < $departuresFilters.length) {
      this.$container.find(this.MONTHS_BOTTOM_BUTTON_SELECTOR).removeClass(this.GLOBAL_HIDDEN_CLASS);

      const rightText = this.$container.find(this.NEXT_MONTH_BUTTON_SELECTOR).data('text')
        .replace('{{monthName}}', $departuresFilters.eq($activeDeparturesFilters.index() + 1).data('month-name').replace(/\d+/g, '').trim());
      this.$container.find(this.NEXT_MONTH_BUTTON_SELECTOR).show().text(rightText);
    }
  }

  sendAvlVisibilityEvent(initIt) {
    if (this.avlEventIsSent) {
      return;
    }

    this.avlEventIsSent = true;

    const labelBlock = this.$container.find(`.${this.MONTHS_BUTTON_ACTIVE_CLASS}`);

    if (!labelBlock.length) {
      return;
    }

    const actionFor = ` - ${this.tourId} - ${this.operatorName}`;

    const label = labelBlock.data('val')
      ? labelBlock.data('val')
      : labelBlock.text();
    let value = 0;
    let action = '';

    const allVariants = this.$container.find(this.VARIANT_SELECTOR).not(this.VARIANT_HIDDEN_CLASS).length;
    const soldVariants = this.$container.find(`${this.VARIANT_SELECTOR}.${this.VARIANT_DISABLED_CLASS}`).not(this.VARIANT_HIDDEN_CLASS).length;

    if (soldVariants > 0) {
      if (soldVariants === allVariants) {
        action = 'All sold out';
        value = soldVariants;
      } else {
        action = 'Percentage of sold out visible';
        value = (100 / allVariants) * soldVariants;
      }
    } else {
      action = 'All dates available';
      value = allVariants;
    }

    this.common.sendGoogleEvent(
      this.availabilityEventCategory,
      action + actionFor,
      label,
      {
        value: Math.round(value),
        nonInteraction: !!initIt,
      },
    );
  }

  sendDeparturesEvent() {
    const availableVariants = this.$container
      .find(this.VARIANT_SELECTOR, this.DEPARTURE_CARD_SELECTOR)
      .not(`.${this.VARIANT_HIDDEN_CLASS}`)
      .not(`.${this.VARIANT_DISABLED_CLASS}`).length;

    const isAnyDepartureAvailable = availableVariants ? '1' : '0';

    // use same event for new cards
    this.common.sendGoogleEvent(
      this.tourDetailEventCategory,
      'Available Dates',
      isAnyDepartureAvailable,
      { nonInteraction: true },
    );
  }

  sendMonthPreselectEvent() {
    this.common.sendGoogleEvent(
      this.tourDetailEventCategory,
      'Month Preselected',
      window.location.hash.includes('months') ? '1' : '0',
      {
        nonInteraction: true,
      },
    );
  }

  sendNextMonthClickedEvent() {
    this.common.sendGoogleEvent(
      this.tourDetailEventCategory,
      'Next Month',
      'Calendar',
    );
  }

  sendMobileDateApplyEvent(dateInfo) {
    this.common.sendGoogleEvent(
      this.tourDetailEventCategory,
      'Date Apply',
      dateInfo,
    );
  }

  sendMobilePaxApplyEvent(paxInfo) {
    this.common.sendGoogleEvent(
      this.tourDetailEventCategory,
      'Pax Selector',
      paxInfo,
    );
  }

  sendShowAvaliabilityEvent(dateAndPaxInfo) {
    this.common.sendGoogleEvent(
      this.tourDetailEventCategory,
      'Show Avaliability',
      dateAndPaxInfo,
    );
  }

  sendOpenAlternativeVersionEvent(currentType) {
    const openType = currentType === 'Group' ? 'Private' : 'Group';

    this.common.sendGoogleEvent(
      this.tourDetailEventCategory,
      'View Tour Click',
      `View ${openType} Version - ${currentType} TDP`,
    );
  }

  selectMonthsByNameArray(monthsName) {
    if (!monthsName) {
      return;
    }

    let hasSelectedMonth = false;

    monthsName.forEach((monthName) => {
      if (hasSelectedMonth) {
        return;
      }

      this.$container.find(this.MONTHS_BUTTON_SELECTOR).each((index, element) => {
        if ($(element).text().trim().toLowerCase() === monthName.replace('-', ' ')) {
          $(element).click();
          hasSelectedMonth = true;
          return false;
        }

        return true;
      });
    });
  }

  static buildErrorMessage(tourName, transportName, monthName, errors) {
    let key = '';
    let errorMessage = '';

    if (tourName) {
      key += 'tour';
    }

    if (transportName) {
      key += key.length ? '-transport' : 'transport';
    }

    if (monthName) {
      key += key.length ? '-month' : 'month';
    }

    errorMessage = errors[key];

    if (tourName) {
      errorMessage = errorMessage.replace('{{tourName}}', tourName);
    }

    if (transportName) {
      errorMessage = errorMessage.replace('{{transportName}}', transportName);
    }

    if (monthName) {
      errorMessage = errorMessage.replace('{{monthName}}', monthName);
    }

    return errorMessage;
  }

  static getHoldButtonClass() {
    return 'js-am-tour-availability__variant-link-button--hold';
  }

  static getBookNowButtonClass() {
    return 'js-am-tour-availability__variant-cta--book';
  }

  static getAvailabilitySectionClass() {
    return 'js-ao-tour-availability';
  }

  static getAvailabilityDeparturesSectionClass() {
    return 'ao-tour-availability__departures';
  }

  static getNextMonthButtonClass() {
    return 'pikaday-next';
  }

  static getMobileApplyDateButtonClass() {
    return 'js-pika-single__mobile-panel-cta';
  }

  static getMobileApplyPaxButtonClass() {
    return 'js-scout-component-date-traveller-select__mobile-cta';
  }

  static getShowAvaliabilityButtonClass() {
    return 'js-scout-component-date-traveller-select__cta';
  }

  checkSimilar() {
    const $similarTour = this.$container.find(this.SIMILAR_SELECTOR);

    if ($similarTour.not('.processed').length === 0) {
      return;
    }

    const similarDates = [];
    $similarTour.not('.processed').each((index, element) => {
      const $currentElement = $(element);
      similarDates.push($currentElement.data('date'));
      $currentElement.addClass('processed');
    });

    const serpDomain = this.$container.data('similar-serp-domain');
    const serpType = this.$container.data('similar-serp-type');
    const serpParams = this.$container.data('similar-serp-params');

    this.common.sendRequest('/api/tour/load', {
      action: 'check_similar',
      length: $similarTour.data('length'),
      dates: similarDates,
      type: serpType,
      params: serpParams,
    }, (data) => {
      if (data && data.status === 'OK' && data.component) {
        $.each(data.component, (elementIndex, value) => {
          if (value >= 3) {
            const $similarTourLink = this.$container.find(`${this.SIMILAR_SELECTOR}[data-date="${elementIndex}"]`);

            $similarTourLink
              .removeClass(this.GLOBAL_HIDDEN_CLASS)
              .attr('href', (index, oldValue) => `${serpDomain}srp/${serpType}-${serpParams}${oldValue}`);
          }
        });
      }
    });
  }

  initiateToolTips() {
    this.$container.on('mouseenter', () => {
      if (!this.texts) {
        this.loadToolTipTexts(() => {
          this.toolTipApply();
        });
      } else {
        this.toolTipApply();
      }
    });
  }

  toolTipApply() {
    this.$container.find(this.VARIANT_VERSION_SELECTOR).each((index, element) => {
      const $element = $(element);

      if (!$element.data('text') && this.texts && this.texts.alt_tour_title) {
        const text = this.texts.alt_tour_title.replace('{{tourName}}', this.tourName);
        $element.data('text', text).addClass('ttip');
      }
    });
    this.common.lib.init('tooltip');
  }

  loadToolTipTexts(callback) {
    this.common.sendRequest('/api/tour/load', {
      action: 'ttip_text',
      id: this.tourId,
    }, (data) => {
      if (data && data.status === 'OK') {
        this.texts = data.texts;

        const availabilityKeys = Object.keys(this.texts);

        for (let i = 0; i < availabilityKeys.length; i += 1) {
          const currentKey = availabilityKeys[i];
          this.texts[currentKey] = this.texts[currentKey].replace(/\\/g, '');
        }

        callback();
      }
    });
  }

  initRoomInformation() {
    this.$container.on('mouseenter', this.ROOM_INFO_ICON_SELECTOR, () => {
      this.common.sendGoogleEvent(
        this.eventCategory,
        'Hover',
        'Accommodation Link',
      );
    });
  }

  calendarPreselectMonth(months) {
    const $travellerDateSelect = $(this.TRAVELLER_SELECT_SLECTOR);

    if (!$travellerDateSelect.length || !months.length) {
      return;
    }

    this.common.lib.init('dayjs', () => {
      // Remove this hacks when we remove v0
      const monthTitle = months[0].split('-')[0];
      $travellerDateSelect.data('preselected', dayjs().month(months[0]).format('MM-Y'));
      $travellerDateSelect.data('month-name', monthTitle.toLowerCase());

      this.$variantsContainer.html('');
      this.load();
      /* ++++++++++++++++++++++++++++++++ */
    });
  }
}
